import React, { useEffect, useState } from 'react';
import {IconoMensajes} from './IconoMensajes';
import {IconoNotificaciones} from './IconoNotificaciones';
import {useNavigate} from 'react-router-dom';
import './HeaderHome.css';

export const ViewHeaderHome = (props) => {
	const navigate = useNavigate();
	/* Destructuring the props object. */
	const {
		goToCafeRural,
		goToInicioMarket,
		logoCuidatia,
		goLogin,
		goToNotificaciones,
		Usuario,
		setUsuario,
		MenuLateral,
		setMenuLateral,
		goToPerfil,
		goToHistorial,
		goToMonitor,
		cerrarSesion,
		goToMensajes,
		gotToMiEmpresa,
		goToMisPacientes,
		goToHome,
		chageMenuLateralAux,
	} = props;

	const [bool, setBool] = useState(true)

	const select = (el, all = false) => {
		el = el.trim()
		if (all) {
		  return [...document.querySelectorAll(el)]
		} else {
		  return document.querySelector(el)
		}
	}

	useEffect(()=>{
		const onscroll = (el, listener) => {
				el.addEventListener('scroll', listener)
			}
		
			let selectHeader = select('#header2')
			if (selectHeader) {
				const headerScrolled = () => {
				if (window.scrollY > 100) {
					selectHeader.classList.add('header-scrolled')
				} else {
					selectHeader.classList.remove('header-scrolled')
				}
				}
				window.addEventListener('load', headerScrolled)
				onscroll(document, headerScrolled)
			}
	}, [])

	const handleHeaderColor = () => {
		let header = select('#header2')
		if(header){
			if(bool){
				header.classList.add('header-selected')
				setBool(false)
			}else{
				header.classList.remove('header-selected')
				setBool(true)
			}
		}
	}

	const [isOpen, setIsOpen] = useState(false);

	const {seleccionado, MenuLateralAux} = props;


	return (
		<>
			{
				/* Checking if the user is undefined, if it is, it sets the user to a default user. */
				Usuario === undefined &&
					setUsuario({
						tipo: 'noRegistrado',
						userName: '',
						email: '',
						imagen: '',
						litaCarrito: [],
					})
			}

			<div className={`header2 centrador  ${(Usuario.tipo !== undefined && Usuario.tipo !== 'noRegistrado') && 'px-0'}`} id='header2'>
							
				<div className='centrador-der-header'>
					{Usuario.tipo !== undefined && Usuario.tipo !== 'noRegistrado' && (
					<div className='area-header'
						onClick={() => {
								if (
									Usuario.tipo === 'usuarioEmpresa' ||
									Usuario.tipo === 'usuarioAdmin' ||
									Usuario.tipo === 'usuarioNormal'
								) {
									chageMenuLateralAux();
									handleHeaderColor();
								} else {
									setMenuLateral(!MenuLateral);
								}
							}}
					>
						{' '}
						<div>
							<div className={`flex gap-2 ${MenuLateralAux ? 'area-header' : 'area-header--oculto'}`}>
								<div>
									<svg 
										xmlns="http://www.w3.org/2000/svg" 
										width="32" 
										height="32" 
										fill="currentColor" 
										className="bi bi-list" 
										viewBox="0 0 16 16">
											<path 
											fill-rule="evenodd" 
											d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
									</svg>
								</div>
								<div>
									{Usuario.tipo === 'usuarioNormal'
									? "Área de clientes"
									: Usuario.tipo === 'usuarioEmpresa' &&
										"Área de profesionales"}
								</div>
							</div>
						</div>
					</div>
					)}
					<div
						className='centrador'
						onClick={
							Usuario.tipo === 'usuarioEmpresa' ? gotToMiEmpresa : goToInicioMarket
						}
					>
						<img
							src={logoCuidatia}
							alt='LogoCuidatia'
							className='hijo logoAdiperHeader'
						/>
					</div>
				</div>
				
			

				{
					/* Checking if the user is not logged in, if it is not, it shows the login button. */
					Usuario.tipo === 'noRegistrado' && (
						<div className='headerHome-centrador'>
							<div className='row headerHome-large'>
								{/* <div
									className='login-boton col-lg-2 col-sm-2 col-xs-2 centrador button'
									style={{margin: '2px'}}
									onClick={goLogin}
								>
									Necesito cuidados
								</div>
								<div
									className='login-boton col-lg-2 col-sm-2 col-xs-2 centrador button'
									style={{margin: '2px'}}
									onClick={() => navigate('/loginEmpresa')}
								>
									Ofrecemos cuidados
								</div> */}
								<div className='header-link centrador'>
									<a className='' href="/cuidados">Cuidatia para la Persona</a>
								</div>
								<div className='header-link centrador'>
									<a className='' href="/proveedores">Cuidatia Corporativo</a>
								</div>
								<div className='header-link centrador'>
									<a className='' href="/historiavida">Historia de Vida</a>
								</div>
								<div className='header-link centrador'>
									<a className='' href="/funcionalidades">Funcionalidades</a>
								</div>
								<div className='header-link centrador'>
									<a className='' href="/sobre-nosotros">Sobre nosotros</a>
								</div>
								<div className='header-link centrador'>
									<a className='' href="/club-cuidatia">Club Cuidatia</a>
								</div>
								<div className='btn login-boton mx-1'
									onClick={()=> navigate('/login')}
								>
									Iniciar sesión
								</div>
								<div className='btn btn-outline-dark mx-1'
									onClick={()=> navigate('/registro')}
								>
									Registrate aquí
								</div>
							</div>
							<div className="headerHome-reduced">
								<div onClick={() => setIsOpen(!isOpen)} className="headerHome-reduced-button">
									<svg class="text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24">
										<path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M5 7h14M5 12h14M5 17h14"/>
									</svg>
								</div>
							</div>
						</div>
					)
				}

				{/* {
					Usuario.tipo !== 'noRegistrado' && (
						<div className='infoUsu'>
							<IconoMensajes
								numMensajes={Usuario.messages}
								goToMensajes={goToMensajes}
							/>
							<IconoNotificaciones
								goToNotificaciones={goToNotificaciones}
								numMensajes={Usuario.messages}
							/>
						</div>
					)
				} */}
			</div>
			
			<div className={`headerHome-reduced-menu ${isOpen ? 'open' : ''}`}>
				<div className='headerHome-reduced-menu-item'>
					<a className='' href="/cuidados">Cuidados</a>
				</div>
				<div className='headerHome-reduced-menu-item'>
					<a className='' href="/proveedores">Proveedores</a>
				</div>
				<div className='headerHome-reduced-menu-item'>
					<a className='' href="/sobre-nosotros">Sobre nosotros</a>
				</div>
				<div className='headerHome-reduced-menu-item'>
					<a className='' href="/club-cuidatia">Club Cuidatia</a>
				</div>
				<div className='headerHome-reduced-menu-item'>
					<a className='' href="/login">Iniciar sesión</a>
				</div>
				<div className='headerHome-reduced-menu-item'>
					<a className='' href="/registro">Registrate aquí</a>
				</div>
			</div>
		</>
	);
};
